import styled, { keyframes } from "styled-components";

const star1 = keyframes`
        0%,
        100% {
            top: 0%;
        }

        50% {
            top: 3%;
    }
`;
const star2 = keyframes`
        0%,
    100% {
        top: 20%;
    }

    50% {
        top: 23%;
    }
`;
const star6 = keyframes`
      0%,
    100% {
        bottom: 15%;
    }

    50% {
        bottom: 18%;
    }
`;
const star7 = keyframes`
      0%,
    100% {
        bottom: 0%;
    }

    50% {
        bottom: 3%;
    }
`;

const CTAStyleWrapper = styled.section`
  width: 100%;
  margin-bottom: 120px;
  .stars_overlay {
    position: relative;
    z-index: 1;

    .footer_stras_sect {
      height: 356px;
      width: 100%;
      position: absolute;
      top: -380px;
      z-index: 0;
      .footer_stars {
        position: relative;
        height: 100%;
        /* width: 100%; */
        span {
          position: absolute;
        }
        .star_1 {
          top: 0%;
          right: 5%;
          animation: ${star1} 4s infinite;
        }
        .star_2 {
          top: 20%;
          left: 0%;
          animation: ${star2} 5s infinite;
        }
        .star_3 {
          top: 34%;
          left: 20%;
          /* animation: star3 4s infinite; */
        }
        .star_4 {
          top: 50%;
          left: 44%;
          /* animation: star4 4s infinite; */
        }
        .star_5 {
          bottom: 26%;
          right: 27%;
          /* animation: star5 4s infinite; */
        }
        .star_6 {
          bottom: 15%;
          right: 10%;
          animation: ${star6} 3.5s infinite;
        }
        .star_7 {
          bottom: 0px;
          left: 10%;
          animation: ${star7} 3.5s infinite;
        }
      }
    }
  }

  .hermes_title_section {
    width: 50%;
    margin: 0 auto;
    img {
      display: none;
    }

    h2,
    h3 {
      margin: 0;
    }
  }

  .hermes_v1_cta_content {
    position: relative;
    z-index: 1;
    margin-top: 180px;

  }

  .cta_social_links {
    max-width: 540px;
    margin: auto;
    margin-bottom: 70px;
    position: relative;
    z-index: 1;

    ul {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0;
      padding: 0;
      li {
        width: 11%;
        height: 60px;
        background: rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(10px);
        display: flex;
        align-items: center;
        justify-content: center;
        a {
          color: #ffffff;
          height: 100%;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          svg {
            font-size: 20px;
          }
          img {
            width: 20px;
            height: 20px;
          }
        }
        &:hover{
          background: rgba(255, 255, 255, 0.2);
        }
      }
      li + li {
        margin-left: 15px;
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .hermes_title_section {
      width: 60%;
    }
  }
  @media only screen and (max-width: 575px) {
    .cta_social_links {
      max-width: 425px;

      ul {
        li {
          height: 48px;
          width: 12%;
          a {
            img {
              height: 14px;
            }
            svg {
              font-size: 14px;
            }
          }
        }
      }
    }
  }

  @media (max-width: 480px) {
    .hermes_title_section {
      width: 60%;
    }
    .stars_overlay{
      .footer_stras_sect{
        height: 200px;
        top: -260px;
      }
    }
    .hermes_v1_cta_content{
      margin-top: 100px;
      margin-bottom: 110px;
    }
    .footer_social_links {
      ul {
        li {
          height: 40px;
          width: 12%;
          a {
            svg {
              font-size: 12px;
            }
            img {
              height: 12px;
            }
          }
        }
      }
    }
  }
`;

export default CTAStyleWrapper;
